import React, { Component } from "react";
import ReactDOM from 'react-dom'; 
import moment from 'moment';
import { LangContext } from "../LangContext.jsx";
class DateFieldValidations extends Component {
	static contextType = LangContext;
    constructor(props) {
        super();
        this.state = {
			cancelValidation:true,
			isChecked:false,
			conditionsError:false,
            options:[{
				param:'1',
				description:'mayor a'
				},{
				param:'2',
				description:'menor a'
				},{
				param:'3',
				description:'igual a'
				}],
				conditions: [],
				master:false,
			};
    }

    handleAgregarCondicion = (e) => { 
        e.preventDefault();
        let existeIgual = false;
        if (this.state.conditions.length >= 2) {
			return;
		}
		
		this.state.conditions.forEach(condition => {
			if (condition.param1 == '3') {
				existeIgual = true;
			}
		});  
		if (existeIgual) {
			return;
		}
		const primerElemento = this.state.options[0].param;
		let dayValue = 2
		if(this.state.conditions.length > 0){
			dayValue = 4;
		}
        const nuevaCondicion = { param1: primerElemento, param2: dayValue, param3: 'day' };
        this.setState((prevState) => ({
            conditions: [...prevState.conditions, nuevaCondicion],
            options: prevState.options.slice(1),
        }), () => {
            this.updateValidationState();
        });
    };

    handleEliminarCondicion = (index, e, param,description) => {
        e.preventDefault();  
        this.setState((prevState) => {
            const newConditions = prevState.conditions.filter((_, i) => i !== index); 
            const newOptions = [{ param: param }, ...prevState.options];
            return {
                conditions: newConditions,
                options: newOptions,
            };
        }, () => {
            this.updateValidationState();
        });
    };

	convertirAValoresEnDias = (condition) => {
			let factor = 1;
			switch (condition.param3) {
				case 'week':
					factor = 7;
					break;
				case 'month':
					factor = 30;
					break;
				case 'year':
					factor = 365;
					break;
				default:
					break;
			}
			const valorEnDias = condition.param2 * factor;
			return   valorEnDias ; 
	};

    handleCondicionChange = (index, campo, valor,condition) => {   
		this.setState({conditionsError:false})
		const estadoAnterior = JSON.parse(JSON.stringify(this.state.conditions));
		if(condition.param3 == 'day'){
			if(valor < 2){
				return ;
			}
		}
        let existeIgual = false; 
        this.state.conditions.map(condition=>{
			if(campo == 'param1'){
				if(condition.param1 == valor){
					existeIgual = true
				}
			}
			})
			if (existeIgual) { 
			return;
		}
        this.setState((prevState) => {
            const nuevasCondiciones = [...prevState.conditions];
            nuevasCondiciones[index][campo] = valor;
            return { conditions: nuevasCondiciones };
        },function(){
			const hoy = moment();
			if(this.state.conditions.length > 1){
				const fechaMinima = hoy.clone().add(this.convertirAValoresEnDias( this.state.conditions[0]), 'days');
				const fechaMaxima = hoy.clone().add(this.convertirAValoresEnDias( this.state.conditions[1]), 'days');
				let diferenciaEnDias = fechaMaxima.diff(fechaMinima, 'days'); 
				if (fechaMinima.isAfter(fechaMaxima) || diferenciaEnDias == 1 || fechaMinima.isSame(fechaMaxima)) {
					this.setState({conditionsError:true})
					this.setState({ conditions: estadoAnterior },function(){
					});
				}  
				this.state.conditions.map(condition=>{
					let convertedValidation = this.convertirAValoresEnDias( condition);
					
				})
			}else{
				this.setState({conditionsError:false})
			}
			
			if(campo == 'param1' && valor == '3' ){ 
				let conditions = this.state.conditions.filter(condition=>{
					if(condition.param1 == '3'){ 
						return condition;
					}
				})
				this.setState({conditions:conditions})
				let options = [{
				param:'1',
				description:'mayor a'
				},{
				param:'2',
				description:'menor a'
				},{
				param:'3',
				description:'igual a'
				}]
				this.setState({options:options})
			}
			});
        this.updateValidationState()
    };

    updateValidationState = () => { 
        const allChildStates = { ...this.state }; 
        this.props.updateValidationState(allChildStates);
    }

	componentDidUpdate(prevProps) { 
		if (this.props.id !== this.props.dateValidationComponent && this.state.isChecked) { 
			this.setState({ isChecked: false });
			this.setState({cancelValidation:true})
			this.setState({master:false})
		} 
		if (this.props.id == this.props.dateValidationComponent && this.state.isChecked == false) { 
			this.setState({ isChecked: true });
			this.setState({cancelValidation:false})
			this.setState({master:true})
		} 
	}

	handleCheckboxChange = () => {
		const { lang } = this.context;
		Swal.fire({
			html: "<b>"+ lang.get('messages.nueva_fecha_de_caducidad') + "</b><br>" +  lang.get('messages.al_seleccionarse_esta_como_fecha_de_caducidad_se_descartara_cualquier_fecha_de_caducidad_asignada_en_la_seccion_de_recurrencia') + "<br>" +  lang.get('messages.estas_seguro_que_deseas_continuar'),
			icon: "warning",
			buttonsStyling: false,
			showCancelButton: true,
			cancelButtonText: lang.get('messages.cancelar'),
			confirmButtonText: lang.get('messages.aceptar'),
			customClass: {
                confirmButton: "btn font-weight-bold btn-primary",
                cancelButton: "btn font-weight-bold btn-secondary"
            }
		}).then((result) => {
            if (!result.isConfirmed) {
                return;
            }else{
				this.setState({master:true})
				this.setState({cancelValidation:false})
				this.setState({isChecked:!this.state.isChecked},function(){
					this.props.onCheckboxChange(true,this.state.master);
				})
			}
        });
		
	};
	componentDidMount() {  
		if (this.props.conditions) {
			let nc = this.props.conditions.map(condition=>{
				const parsedArray = JSON.parse(condition.value); 
				const param1 = parsedArray[0]; 
				const param2 = parsedArray[1];  
				return {
					...condition,
					param2: param1,
					param3: param2,
					param1: condition.internal_validation_id,
				};
			}) 
			if (this.props.conditions != null) {
				this.setState({
					conditions: nc,  
				},function(){
					this.updateValidationState()  
					/*
					if(this.props.document.document_field_validation_id == this.props.id){
						this.props.onCheckboxChange(true,this.state.master);
					}  */
				})
        	}
		}
		const { lang } = this.context;
		const updatedOptions = [{
			param:'1',
			description:lang.get('messages.mayor_a')
			},{
			param:'2',
			description:lang.get('messages.menor_a')
			},{
			param:'3',
			description:lang.get('messages.igual_a')
			}];
	
		this.setState({
		  options: updatedOptions
		});
    }
	cancelValidation= ()=>{
		this.setState({master:false})
		this.setState({cancelValidation:true})
		this.setState({isChecked:false},function(){
			this.props.onCheckboxChange(false,this.state.master);
		})
	}
    render() {
		const { lang } = this.context; 
        return (
            <div>
				<div className="col-sm-12  mt-6">
					{/**
					<label className="text-left">{lang.get('messages.este_campo_de_fecha_sera_utilizado_para_caducar_el_documento')}</label>
					<div className="d-flex ">
						<div className=" d-flex">
							<div className="col-md-6  font-size-h4 selectedRadio">
								<input type="radio" value="once"  checked={this.state.isChecked}
									onChange={this.handleCheckboxChange}  /> {lang.get('messages.si')} {this.state.isChecked}
							</div> 
							<div className="col-md-12 font-size-h5 text-dark ">
								<input type="radio" value="yearly"  checked={this.state.cancelValidation}
									onChange={this.cancelValidation} /> {lang.get('messages.no')}
							</div>
						</div> 
					</div> 
					 */}
					
					{this.state.isChecked &&
								<div class="alert alert-soft-warning mt-3 mb-3 d-flex align-items-center" role="alert">
								<div>
									<span class="flaticon2-warning mr-2 icon-3x"></span>
								</div>
								<div>
									<h3>{lang.get('messages.alerta')}</h3> 
									{lang.get('messages.la_fecha_de_caducidad_del_documento_sera_reemplazada_por_este_campo_los_parametros_que_se_definieron_en_la_seccion_de_recurrencia_seran_reemplazados')}
								</div>
							</div>
							}
				</div>  
            	{this.state.conditions.map((condition, index) => (
				<div key={index} className="d-flex align-items-center mt-3 gap-1">
					<div  className="col-md-4" >Campo: {this.props.fieldName} </div>
					<select
					className="form-control"
					value={condition.param1.toString()}
					onChange={(e) => this.handleCondicionChange(index, 'param1', e.target.value,condition)}
					>
					<option value="1">{lang.get('messages.no_menor_a')}</option>
					<option value="2">{lang.get('messages.no_mayor_a')}</option>
					<option value="3">{lang.get('messages.igual_a')}</option>
					</select> 
					<input className="form-control col-md-2" 
						type="number"
						value={condition.param2}
						onChange={(e) => this.handleCondicionChange(index, 'param2', e.target.value,condition)}
 
					/> 
					<select
					className="form-control col-md-3"
					value={condition.param3}
					onChange={(e) => this.handleCondicionChange(index, 'param3', e.target.value,condition)}
					>
					<option value="day">{lang.get('messages.dia')}</option>
					<option value="week">{lang.get('messages.semana')}</option>
					<option value="month">{lang.get('messages.mes')}</option>
					<option value="year">{lang.get('messages.ano')}</option>
					</select>
					<span onClick={(e) => this.handleEliminarCondicion(index, e,condition.param1,condition.description)} className="flaticon2-cross mx-2" style={{ color: '#844AFF' }}></span> 
					
				</div>
				))}
				{this.state.conditionsError &&
				<div className="text-danger justify-content-around mt-3">
					{lang.get('messages.estas_intentando_ingresar_rangos_de_fecha_invalidos')}
				</div>
				}
				<div className="d-flex align-items-center cursor-pointer">
					<span className="mt-3 text-primary" onClick={this.handleAgregarCondicion}> <small className="flaticon2-plus text-primary"></small> {lang.get('messages.agregar_nueva_condicion')}</span>
				</div>
			</div>
        );
    }
}

export default DateFieldValidations;

if (document.getElementById('DateFieldValidations')) {
    ReactDOM.render(<DateFieldValidations />, document.getElementById('DateFieldValidations'));
}
